<template>
  <div class="thank-popup shop-popup">
    <div class="content content-thank">
      <img
        @click="$parent.isOpenThank = false"
        src="@/assets/images/shop-close.svg"
        class="close"
      />
      <h5>{{ textH5 }}</h5>
      <h6 v-html="textH6"></h6>
      <button v-if="urlButton" @click="openButtonUrl">Перейти</button>
      <button v-else @click="$parent.isOpenThank = false">
        Понятно, закрыть
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    textH5: String,
    textH6: String,
    urlButton: String,
  },
  methods: {
    openButtonUrl() {
      location.href = this.urlButton;
    },
  },
};
</script>
